import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { ContactStatisticBulkActions } from 'widgets/ContactStatistic'
import type { PowerDialerContactsStore } from 'pages/powerDialer/pages/view/store/powerDialerContactsStore'
import { useContactsTableRows } from 'pages/powerDialer/pages/view/ui/PowerDialerContacts/PowerDialerContactsTable/useContactsTableRows'
import styles from './styles.module.scss'
import { getColumns } from './getColumns'

interface IPowerDialerContactsTableProps {
  powerDialerContactsStore: PowerDialerContactsStore
}

export const PowerDialerContactsTable = observer(
  ({ powerDialerContactsStore }: IPowerDialerContactsTableProps) => {
    const {
      isLoading,
      contacts,
      onOpenContactsDetails,
      scrollToTopTrigger,
      search,
      contactsTagsModalStore,
      tableStore,
      onSuccessDelete,
    } = powerDialerContactsStore

    const columns = useMemo(() => getColumns(onOpenContactsDetails), [onOpenContactsDetails])
    const rows = useContactsTableRows(contacts)

    if (!isLoading && !contacts.length) {
      return <NoResultsFound boxProps={{ flexGrow: 1, height: undefined }} />
    }

    return (
      <div className={styles.table}>
        <Table
          ariaLabel={'PowerDialerContactsTable'}
          store={tableStore}
          columns={columns}
          rows={rows}
          emptyStateProps={{
            text: 'No contacts found',
            noIcon: true,
            boxProps: { flexGrow: 1, height: undefined },
          }}
          sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
          scrollToTOpTrigger={scrollToTopTrigger}
          withCheckbox
          headerLeftContentProps={{
            actionsContent: (
              <ContactStatisticBulkActions
                contactsTagsModalStore={contactsTagsModalStore}
                selectedContactIds={tableStore.selectedRows.map((row) => row.id)}
                search={search}
                onSuccessDelete={onSuccessDelete}
                withNewActions
              />
            ),
          }}
        />
      </div>
    )
  }
)
